import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { MenuState, state } from './state';
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';

const module: Module<MenuState, RootState> = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};

export default module;
export type { MenuState };
